<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'm/task-process/more/help-requests' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()" class="close-modal-button">
        <ion-icon slot="icon-only" name="close-circle-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ng-container *ngFor="let helpAction of helpReqsAndAnswers; last as last">
    <div *ngIf="helpAction.dayIndicatorFormat" class="bubble-day-indicator">
      <span>{{ helpAction.datetime | dateTimezone: helpAction.dayIndicatorFormat }}</span>
    </div>
    <app-message-in-task-process
      [message]="helpAction"
      [taskProcessContext]="taskProcessContext"
      [isAnnotationOrHelpModal]="true">
    </app-message-in-task-process>

    <div *ngIf="last && isTaskStateHelpRequested && canAnswerHelpRequest">
      <ng-container *ngTemplateOutlet="helpMessage; context: { helpRequestId: helpAction.helpRequestId }">
      </ng-container>
    </div>
  </ng-container>

  <div *ngIf="!isTaskStateHelpRequested">
    <ng-container *ngTemplateOutlet="helpMessage"></ng-container>
  </div>
</ion-content>

<ng-template #helpMessage let-helpRequestId="helpRequestId">
  <div [class.separator-bar]="helpReqsAndAnswers?.length">
    <textarea
      [id]="(helpRequestId ? 'answer' : 'help') + '-message'"
      [attr.data-testid]="(helpRequestId ? 'answer' : 'help') + '-message'"
      [formControl]="messageControl"
      (click)="onTextareaClicked($event)"
      rows="4"
      class="alc-annotations-and-help-requests-textarea"
      [placeholder]="placeholderLabel"></textarea>
    <div class="buttons-container">
      <ion-button
        data-testid="submit-message"
        (click)="submit(helpRequestId)"
        [disabled]="messageControl.invalid || messageControl.disabled">
        <span>{{ buttonLabel }}</span>
      </ion-button>
    </div>
  </div>
</ng-template>
